export const defaultOptions = {
    maxSize: 720,
    quality: undefined,
    type: 'image/jpeg',
};
